export function compareTotalScoreAndPenalty(a, b) {
    if (a.totalScore === b.totalScore) {
        return (a.penalty || 1e12) - (b.penalty || 1e12); // TODO was Infinity
    }
    return (b.totalScore || -1) - (a.totalScore || -1);
}

export function compareContestUsers(a, b) {
    if (a.haveSubmitted() !== b.haveSubmitted()) {
        return b.numSubmissions - a.numSubmissions;
    } else {
        return compareTotalScoreAndPenalty(a, b);
    }
}

// Calculate the score across a meta-contest composed of multiple contests
export function compareMetaContestUsers(a, b) {
    if (a.metaScore === b.metaScore) {
        return compareContestUsers(a, b);
    }
    return b.metaScore - a.metaScore;
}
